export default function boxesCounter() {
    const recomendedArea = document.querySelector('#area-recomended');
    const items = document.querySelectorAll('section.boxes-keep .item');

    if (!recomendedArea || !items.length) return;

    const createCount = () => {
        const div = document.createElement('div');
        div.className = 'count';
        div.textContent = '0';
        return div;
    };

    const createCounter = () => {
        const div = document.createElement('div');
        div.className = 'counter';
        div.innerHTML = `<div class="minus"></div><div class="plus"></div>`;
        return div;
    };

    function recalculateArea() {
        let total = 0;
        document.querySelectorAll('section.boxes-keep .count').forEach(countEl => {
            const parent = countEl.closest('.item');
            const area = +parent.dataset.area || 0;
            const count = parseInt(countEl.textContent) || 0;
            total += area * count;
        });

        const rounded = Math.ceil(total) > 0 ? Math.ceil(total) : 1;
        recomendedArea.textContent = rounded;

        const btn = document.querySelector('section.boxes-keep a.btn');
        if (btn) btn.dataset.order = `Забронировать бокс ${rounded} м2`;
    }

    items.forEach(item => {
        item.addEventListener('mouseenter', () => {
            if (!item.querySelector('.counter')) item.append(createCounter());
            if (!item.querySelector('.count')) item.append(createCount());
            item.querySelector('.counter').style.display = 'flex';
            item.querySelector('.count').style.display = 'block';
        });

        item.addEventListener('mouseleave', () => {
            const countEl = item.querySelector('.count');
            if (!item.classList.contains('visible') && countEl && countEl.textContent === '0') {
                item.querySelector('.counter').style.display = 'none';
                countEl.style.display = 'none';
            }
        });

        item.addEventListener('click', e => {
            if (e.target.classList.contains('plus')) {
                const countEl = item.querySelector('.count');
                countEl.textContent = parseInt(countEl.textContent) + 1;
                recalculateArea();
            }

            if (e.target.classList.contains('minus')) {
                const countEl = item.querySelector('.count');
                if (parseInt(countEl.textContent) > 0) {
                    countEl.textContent = parseInt(countEl.textContent) - 1;
                    recalculateArea();
                }
            }
        });
    });
}
